import reportWebVitals from '@helpers/reportWebVitals.helper'
// import { render } from 'preact'
// import 'preact/debug'
import React from 'react'
import App from './App'
import { createRoot } from 'react-dom/client'
import './i18n'

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
